<template>
 
             
          <div v-if="adminrights" class="w3-card-4">
                <header class="w3-container w3-theme-d2">
                    <h3>Customer Remedials</h3>
                </header>
                <div style="padding:10px">
                    <large-button class="w3-theme-dark" v-if="adminrights" @click="$router.push('/admin/customerremedials/processing')">Current Remedials</large-button>
                    <large-button class="w3-theme-dark" @click="$router.push('/admin/customerremedials/declined')">Declined Remedials</large-button>
                </div>
                <footer class="w3-small"  style="padding:10px"><b>Here you can process customer remedials or view declined remedials.  When processing remedials notifications are sent to customers instantly.</b></footer>
          </div>       
    

    
    
</template>


<script> 
  export default {    
   props:["adminrights","sysadmin"]
  };
</script>



// WEBPACK FOOTER //
// src/components/home/CustomerRemedialsTile.vue